/* Cenove vyzvy na celem webu: tlacitko v hero, prouzek na seriich, vysouvaci karta, tlacitko v paticce */
(function () {
  var PRICE_URL = '/pages/orientacni-ceny#cenik';
  var path = location.pathname;
  var onPricing = path.indexOf('/pages/orientacni-ceny') === 0;
  var isCollection = path.indexOf('/collections/') === 0;
  var ARROW = '<svg aria-hidden="true" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var TAG = '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7" cy="7" r="1.5"/></svg>';
  var FLAKE = '<svg aria-hidden="true" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 2v20M4.9 4.9l14.2 14.2M2 12h20M4.9 19.1 19.1 4.9M9 3l3 3 3-3M9 21l3-3 3 3M3 9l3 3-3 3M21 9l-3 3 3 3"/></svg>';

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function closedTeaser() { try { return sessionStorage.getItem('txPriceTeaser') === 'closed'; } catch (e) { return false; } }
  function closeTeaser() { try { sessionStorage.setItem('txPriceTeaser', 'closed'); } catch (e) {} }

  ready(function () {
    if (onPricing) return;

    /* 1) Tlacitko "Kolik to stoji?" na uvodnich fotkach */
    document.querySelectorAll('.hero--has-image .hero__text-content').forEach(function (tc) {
      if (tc.querySelector('.tx-hero-price')) return;
      var wrap = document.createElement('div');
      wrap.className = 'hero__link tx-hero-price';
      wrap.innerHTML = '<a class="tx-hero-price__btn" href="' + PRICE_URL + '">' + TAG + '<span>Kolik to stojí?</span></a>';
      tc.appendChild(wrap);
    });

    /* 2) Prouzek pod uvodni fotkou na strankach serii */
    if (isCollection && !document.querySelector('.tx-pricebar')) {
      var hero = document.querySelector('.hero--has-image');
      if (hero) {
        var sec = hero.closest('.shopify-section') || hero;
        var bar = document.createElement('div');
        bar.className = 'tx-pricebar';
        bar.innerHTML = '<div class="page-width"><a class="tx-pricebar__inner" href="' + PRICE_URL + '">' +
          '<span class="tx-pricebar__icon">' + FLAKE + '</span>' +
          '<span class="tx-pricebar__text"><strong>Kolik bude stát vaše hala?</strong><span>Orientační ceny podle rozměru a sněhové oblasti – i se sněhovou mapou pro vaši adresu.</span></span>' +
          '<span class="tx-pricebar__cta">Zobrazit ceník ' + ARROW + '</span></a></div>';
        sec.parentNode.insertBefore(bar, sec.nextSibling);
      }
    }

    /* 3) Tlacitko "Zjistit cenu" ve vyzve v paticce */
    document.querySelectorAll('[class^="txfc-"] .txfc__btns').forEach(function (b) {
      if (b.querySelector('.tx-footer-price')) return;
      var a = document.createElement('a');
      a.className = 'txfc__btn txfc__btn--ghost tx-footer-price';
      a.href = PRICE_URL;
      a.innerHTML = TAG + ' Zjistit cenu';
      var first = b.firstElementChild;
      if (first && first.nextSibling) b.insertBefore(a, first.nextSibling); else b.appendChild(a);
    });

    /* 4) Vysouvaci karta s cenikem po odscrollovani (schova se u formularu a v paticce) */
    if (closedTeaser()) return;
    var card = document.createElement('div');
    card.className = 'tx-teaser';
    card.setAttribute('role', 'complementary');
    card.setAttribute('aria-label', 'Orientační ceny hal');
    card.innerHTML = '<button type="button" class="tx-teaser__close" aria-label="Zavřít">&times;</button>' +
      '<div class="tx-teaser__eyebrow">' + FLAKE + ' Orientační ceny</div>' +
      '<div class="tx-teaser__title">Kolik stojí hala u vás?</div>' +
      '<p class="tx-teaser__text">Vyberte rozměr a sněhovou oblast – cenu uvidíte hned. Hala 10 × 20 m <strong>od 319 000 Kč</strong> bez DPH.</p>' +
      '<a class="tx-teaser__btn" href="' + PRICE_URL + '">Spočítat moji halu ' + ARROW + '</a>';
    document.body.appendChild(card);

    var dismissed = false, armed = false, last = 0, pending = null;
    var SEL = 'form, [class*="elfsight-app"], [class*="elfsight-sapp"], .site-footer, [class^="txfc-"]';
    function blockerInView() {
      var els = document.querySelectorAll(SEL), vh = window.innerHeight;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.closest('#SiteHeader, .site-header, .tx-teaser, [data-txm], .drawer, #NavDrawer, #CartDrawer')) continue;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.width > 0 && r.top < vh * 0.85 && r.bottom > vh * 0.15) return true;
      }
      return false;
    }
    function update() {
      last = Date.now();
      if (dismissed) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (!armed && h > 0 && window.scrollY / h > 0.25) armed = true;
      if (!armed) return;
      if (blockerInView()) card.classList.remove('is-visible'); else card.classList.add('is-visible');
    }
    window.addEventListener('scroll', function () {
      if (Date.now() - last > 120) { update(); }
      clearTimeout(pending);
      pending = setTimeout(update, 150);
    }, { passive: true });
    card.querySelector('.tx-teaser__close').addEventListener('click', function () { dismissed = true; card.classList.remove('is-visible'); closeTeaser(); });
    card.querySelector('.tx-teaser__btn').addEventListener('click', closeTeaser);
  });
})();
